import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useForm } from 'react-hook-form-v7';
import type { Resolver } from 'react-hook-form-v7';
import { yupResolver } from '@hookform/resolvers/yup';

import type { WizardFormValues } from '@onboarding/presentation/types';
import { WIZARD_FORM_DEFAULT_VALUES } from '@onboarding/presentation/types';
import { buildWizardSchema } from '@onboarding/presentation/schemas';

/**
 * Initializes the react-hook-form instance for the entire onboarding wizard.
 *
 * Single source of truth for all wizard step values. Validation is performed
 * per-step via `methods.trigger(STEP_FIELDS[currentStep])` from the page.
 */
export const useOnboardingWizardForm = () => {
  const { t } = useTranslation('onboarding');

  // @hookform/resolvers v1 ships a broader Resolver signature than react-hook-form v7 expects,
  // hence the cast to Resolver<WizardFormValues>.
  const resolver = useMemo(() => (yupResolver(buildWizardSchema(t)) as unknown) as Resolver<WizardFormValues>, [t]);

  return useForm<WizardFormValues>({
    resolver,
    mode: 'onBlur',
    defaultValues: WIZARD_FORM_DEFAULT_VALUES,
  });
};
